// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
// Others
import masterDataApi from '~/apis/masterData';
import { GET_LIST_MASTER_DATA } from '~/utils/constants/actionType';
import { IQueryMasterData } from '~/utils/interface/masterData';

export const getListMasterData = createAsyncThunk(
  GET_LIST_MASTER_DATA,
  async (params: IQueryMasterData, { rejectWithValue }) => {
    try {
      const resp = await masterDataApi.getListMasterData(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
